var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.50034V12H2.49966L9.87199 4.62767L7.37233 2.12801L0 9.50034ZM11.8051 2.6946C11.8669 2.63293 11.9159 2.55968 11.9493 2.47904C11.9828 2.3984 12 2.31196 12 2.22466C12 2.13736 11.9828 2.05092 11.9493 1.97028C11.9159 1.88964 11.8669 1.81639 11.8051 1.75472L10.2453 0.194936C10.1836 0.133142 10.1104 0.0841172 10.0297 0.0506674C9.94908 0.0172176 9.86264 0 9.77534 0C9.68804 0 9.6016 0.0172176 9.52096 0.0506674C9.44032 0.0841172 9.36707 0.133142 9.3054 0.194936L8.08557 1.41477L10.5852 3.91443L11.8051 2.6946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.16376c5483e8d2e654ab7e570b33b4eb.svg";
export { ForwardRef as ReactComponent };